import {
    OPEN_DIALOG, HIDE_DIALOG, //modals
    CHANGE_SECTION, SET_SECTIONS,
    NAVIGATION, //navigation
    SET_SAVE_STATE_PENDING,
    GET_USER_PROFILE,
    SET_SELECTED_USER_CENTRO_PROFILE,
    LOADING
} from '../constants/action_types';

//import axios from 'axios';
//import * as config from '../constants/configuration';

import { getData } from './redux_data';

import history from '../history';

export function openDialog(modalType, modalProps, id, disableBackdrop, maxWidth) {
    return {
        type: OPEN_DIALOG,
        modalType: modalType,
        modalProps: modalProps,
        dialogid: id,
        disableBackdrop: disableBackdrop,
        maxWidth: maxWidth
    };
}

export function hideDialog() {
    return {
        type: HIDE_DIALOG,
    };
}

export function loading(value) {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: value })
    }
}

export function changeSelectedSection(newSection) {
    return {
        type: CHANGE_SECTION,
        payload: newSection
    }
}

export function setSections(sections) {
    return {
        type: SET_SECTIONS,
        payload: sections
    }
}

export function navigate(location) {
    return (dispatch, getState) => {

        dispatch({ type: NAVIGATION, payload: location })
        history.push('/' + location);

    }
}

export function setSaveState(pending) {
    return (dispatch, getState) => {
        dispatch({ type: SET_SAVE_STATE_PENDING, payload: pending })
    }
}

export function getUserProfile(id, kd) {

    return getData('usuarios/' + id, GET_USER_PROFILE, {kd: kd});
}

export function setUserProfileUsuarioCentro(id) {
    return (dispatch, getState) => {
        dispatch({ type: SET_SELECTED_USER_CENTRO_PROFILE, payload: id })
    }
}
